import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import lock from "../assets/img/lock.png";
import profile from "../assets/img/profile.png";
import helpIcon from "../assets/img/Help-icon.png";
import viewIcon from "../assets/img/eye.png";
import hideIcon from "../assets/img/invisible.png";
import contract from "../assets/img/login-image.jpg";

import AuthService from "../services/auth.service";
import { useAuth } from "../contexts/AuthContext";
import Header from "components/Header/Header";
import tokenMonitor from "services/tokenMonitor";


const required = (value) => {
  if (!value) {
    return (
      <div className="alert-info" role="alert">
        This field is required!
      </div>
    );
  }
};

const HomeLogin = () => {

  const {login} = useAuth();
  const [emailSignIn, setEmailSignIn] = useState("");
  const [passwordSignIn, setPasswordSignIn] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  let navigate = useNavigate();
  const formSignIn = useRef();
  const checkBtn = useRef();

  const onChangeEmailSignIn = (e) => {
    setEmailSignIn(e.target.value);
  };
  const onChangePasswordSignIn = (e) => {
    setPasswordSignIn(e.target.value);
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    setMessage("");
    setLoading(true);

    formSignIn.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      try {
        //navigate("/user/dashboard");

        // Login and get user data, including role
        const user = await login({
          emailSignIn: emailSignIn,
          passwordSignIn: passwordSignIn
        });

        // Restart token monitoring after successful login
        tokenMonitor.restart();

        // Check user role and redirect accordingly
        if (user.roles && user.roles.includes("ROLE_ADMIN")) {
          navigate("/admin/users");
        } else {
          navigate("/user/dashboard");
        }
      } catch (error) {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setLoading(false);
        setMessage(resMessage);
      }
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="homeSection">
        <div className="homeSection-content ">
          <div className="log-txt hiiidd">
            <h1>Swift and secure transaction with ease</h1>
          </div>

          <div className="finc-hero-container">
            <div className="finc-image-wrapper">
              <img
                src={contract}
                alt="Business professional working with financial documents"
                fill
                className="finc-hero-image"
              />
              <div className="finc-overlay" />
              <div className="finc-content-container">
                <div className="finc-text-center">
                  <h2 className="finc-heading">
                    Swift and secure <br /> transactions with ease
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className="wrapper-login">
            <Form
              onSubmit={handleLogin}
              ref={formSignIn}
              className="signup-form"
            >
              <div className="container">
                <div className="navv">Sign in</div>
              </div>
              <div className="inputs-1">
                <div className="input-feild-1">
                  <i class="input-icon">
                    <img src={profile} />{" "}
                  </i>
                  <Input
                    type="text"
                    className="input-control"
                    name="email"
                    placeholder="Username"
                    value={emailSignIn}
                    onChange={onChangeEmailSignIn}
                    validations={[required]}
                  />

                  <i class="input-icon-right his" title="This is a helper">
                    <img src={helpIcon} />
                  </i>
                </div>
                <div className="input-feild-1">
                  {/* <i class="input-icon fa-solid fa-lock"></i> */}

                  <i class="input-icon">
                    <img src={lock} />{" "}
                  </i>
                  <Input
                    type={showPassword ? "text" : "password"}
                    className="input-control"
                    name="password"
                    placeholder="Password"
                    value={passwordSignIn}
                    onChange={onChangePasswordSignIn}
                    validations={[required]}
                  />
                  <i
                    class="input-icon-right his"
                    title="This is a helper"
                    onClick={togglePasswordVisibility}
                  >
                    <img src={showPassword ? hideIcon : viewIcon} />
                  </i>
                </div>
              </div>

              <div className="checkbox-1 forP">
                <span className="box-1 forgot">Forgot Password?</span>{" "}
              </div>

              <div className="button-div-1">
                <button className="loginbutton-1" disabled={loading}>
                  {loading && (
                    <span className="spinner-border spinner-border-sm"></span>
                  )}
                  <span>Sign In</span>
                </button>
              </div>
              {/* <div className="checkbox-1 forR">
                <span className="box-1 bbox">
                  Don't have an account?{" "}
                  <a href="/signup">
                    <span className="ctaa">Sign Up</span>
                  </a>
                </span>
              </div> */}

              {message && (
                <div className="form-group">
                  <div className="alert-info" role="alert">
                    {message}
                  </div>
                </div>
              )}
              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomeLogin;
